/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      DEFAULT_ERROR: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Volver al catálogo',
              link: URLS.VTL_CATALOG,
              color: BUTTON_COLOR.BLUE,
            },
          ],
        },
      },
      INCORRECT_PARAMS: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Volver al catálogo',
              link: URLS.VTL_CATALOG,
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          title: 'Uppss... algo ha ido mal.',
          msg: ['Por favor, inténtalo más tarde.'],
          errorName: 'Parámetros recibidos en el flujo de compra incorrectos.',
        },
      },
      FUNDED_URL_ERROR: {
        errorType: CONTENT.ERROR_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Volver al catálogo',
              link: URLS.VTL_CATALOG,
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          title: 'Uppss... algo ha ido mal.',
          msg: ['Error al generar url de financiación.'],
          errorName: 'Error al generar url de financiación.',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
